import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/http/user.service';
import { UserCreateEdit } from 'src/app/models/user.model';
import { ApplicationService } from 'src/app/services/http/application.service';
import { DictionaryItem, DictionaryItemGuid } from 'src/app/models/shared/dictionaryItem.model';
import { UtService } from 'src/app/services/http/ut.service copy';
import { BuService } from 'src/app/services/http/bu.service';
import { UtilityService } from 'src/app/services/http/utility.service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-user-create-edit',
  templateUrl: './user-create-edit.component.html',
  styleUrls: ['./user-create-edit.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(143%, 0, 0)'
      })),
      transition('in => out', animate('900ms ease-in-out')),
      transition('out => in', animate('900ms ease-in-out'))
    ]),
  ], host: {
    '(document:click)': 'handleClick($event)',
  },
})
export class UserCreateEditComponent implements OnInit {

  showShadow = false;
  @Input() animationState = 'out';
  @Output() parentComp = new EventEmitter();
  @ViewChild("f") f: any;

  selectedUser = new UserCreateEdit();

  applications: DictionaryItemGuid[] = [];
  selectedBus: DictionaryItem[] = [];
  businessUnits: DictionaryItem[] = [];
  undertakings: any[] = [];
  utilities: DictionaryItem[] = [];

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];

  phoneNumberObject = {
    countryCode: '',
    dialCode: 0,
    e164Number: 0,
    internationalNumber: 0,
    nationalNumber: 0,
    number: ''
  };

  constructor(private ref: ElementRef,
    private toastr: ToastrService, private utService: UtService, private utilityService : UtilityService,
    private applicationService: ApplicationService, private buService : BuService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.getApplications();
    this.getUtility();
  }

  isActiveUtility(app: DictionaryItem) {
    return this.selectedUser.utilityIds.some(item => item === app.value);
  }
  activateUtility(u : DictionaryItem){
    if(!this.isActiveUtility(u)){
      this.selectedUser.utilityIds.push(u.value)
    }
    else{
      this.selectedUser.utilityIds = this.selectedUser.utilityIds.filter(obj => u.value != obj);
    }
  }

  handleClick(event: any) {
    const isSliderClicked = event.target.closest('.slider');
    if (this.animationState === 'in')
      if (this.ref.nativeElement.contains(event.target) || event.target === this.ref.nativeElement) {
        if (!isSliderClicked) {
          this.changeState(2);
        }
      }
  }

  getUser(id : any){
    this.userService.getByGuid(id).subscribe(response => {
      if (response.status === 200) {
        this.selectedUser = response.data;
        this.selectedUser.undertakings.forEach(element => {
          if(!this.isActiveBu(element.buId))
          {
            let temp = this.businessUnits.find(x => x.value === element.buId);
            if(temp)
              this.selectedBus.push(temp);
          }
        });
      } else{
        this.toastr.error(response.message);
        this.changeState(2)
      }
    }, error => {
      this.toastr.error('An error occurred.');
      this.changeState(2)
    });
  }

  toggleShowDiv(divName: string) {
    if (divName === 'open') {
      this.animationState = 'in';
    } else if (divName === 'close')
      this.animationState = 'out';
  }

  changeState(number: Number, data?: any) {
    if (data) {
      this.getUser(data.id);
    }
    else {
      this.selectedUser = new UserCreateEdit();
      
    }
    if (number === 1) {
      this.toggleShowDiv("open");
      this.showShadow = true;

    }
    if (number === 2) {
      this.toggleShowDiv("close");
      this.showShadow = false;
      this.f.submitted = false;
      this.selectedBus = [];
    }
  }

  save() {
    this.selectedUser.phoneNumber = this.phoneNumberObject?.number;
    this.userService.save(this.selectedUser).subscribe(response => {
      if (response.status === 200) {
        this.toastr.success(response.message);
        this.parentComp.emit()        
        this.changeState(2)
      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });

  }

  getApplications() {
    this.applicationService.getAllForOptions().subscribe(response => {
      if (response.status === 200) {
        this.applications = response.data;
      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }
  getUtility() {
    this.utilityService.getAllForOptions().subscribe(response => {
      if (response.status === 200) {
        this.utilities = response.data;

      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  isActive(app: DictionaryItemGuid) {
    return this.selectedUser.applications.some(item => item.value === app.value);
  }

  public activate(app: DictionaryItemGuid) {
    if (!this.isActive(app)) {
      this.selectedUser.applications.push(app)
    }
    else {
      const index = this.selectedUser.applications.findIndex(item => item.value === app.value);
      this.selectedUser.applications.splice(index, 1);
    }
  }
  
  isActiveBu(buId: number) {
    return this.selectedBus.some(item => item.value === buId);
  }

  public activateBu(bu: DictionaryItem) {
    
    if (!this.isActiveBu(bu.value)) {
      this.selectedBus.push(bu)
      this.selectedUser.undertakings = this.selectedUser.undertakings.filter(obj => obj.buId != bu.value);
      let obj = this.undertakings.filter(obj => bu.value == obj.buId);
      obj.forEach(x=>this.selectedUser.undertakings.push(x))
    }
    else {
      const index = this.selectedBus.findIndex(item => item.value === bu.value);
      this.selectedBus.splice(index, 1);
      this.selectedUser.undertakings = this.selectedUser.undertakings.filter(obj => obj.buId != bu.value);
    }
    console.log(this.selectedUser.undertakings,'ut')
    console.log(this.selectedBus,'bu')
  }
  
  isActiveUt(utId: number) {
    return this.selectedUser.undertakings.some(item => item.id === utId);
  }

  public activateUt(event : any,ut: any) {
    event.stopPropagation()
    if (!this.isActiveUt(ut.id)) {
      this.selectedUser.undertakings.push(ut)
    }
    else {
      const index = this.selectedUser.undertakings.findIndex(item => item.id === ut.id);
      this.selectedUser.undertakings.splice(index, 1);
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z]/g, '');
  }

  onNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/(?!^)\+|[^0-9+]/g, '');

    if (input.value.indexOf('+') > 0) {
      input.value = input.value.replace(/\+/g, ''); // Remove "+" if not at the start
    }
  }
  public enableOTP() {
    this.selectedUser.twoFactorEnabled = !this.selectedUser.twoFactorEnabled;
  }
}



